import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { lazy, Suspense } from "react";

const NXtraining = lazy(() => import("../Pages/NXtraining"));
const CATIACAATraining = lazy(() => import("../Pages/CATIACAATraining"));
const CreoTraining = lazy(() => import("../Pages/CreoTraining"));
const SoildworksAPI = lazy(() => import("../Pages/SoildworksAPI"));
const AutoCAD = lazy(() => import("../Pages/AutoCAD"));
const PythonCATIA = lazy(() => import("../Pages/PythonCATIA"));
const RevitAPI = lazy(() => import("../Pages/RevitAPI"));
const AutodeskInventorAPI = lazy(() => import("../Pages/AutodeskInventorAPI"));

const BuyLicense = lazy(() => import("../Pages/BuyLicense"));
const Dashboard = lazy(() => import("../Components/Dashboard"));
const Consulting = lazy(() => import("../Pages/Consulting"));
const Training = lazy(() => import("../Pages/Training"));
const ContactButton = lazy(() => import("../Components/ContactButton"));

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <Dashboard />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/Consulting",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <Consulting />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/Automation-Training",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <Training />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/Buy-License",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <BuyLicense />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/NX-Open-Customization-Automation-Training",
    element:  (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <NXtraining />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/CATIA-CAA-Customization-Automation-Training",
    element:  (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <CATIACAATraining />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/Creo-Toolkit-Customization-Automation-Training",
    element:  (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <CreoTraining />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/Soildworks-API-Customization-Automation-Training",
     element:  (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <SoildworksAPI />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/AutoCAD-.NET-API-Automation-Training",
     element:  (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <AutoCAD />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/Python-CATIA-Customization-Automation",
     element:  (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <PythonCATIA />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/Autodesk-Revit-API-Customation-Automation",
    element:  (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <RevitAPI />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
  {
    path: "/Autodesk-Inventor-API-Customation-Automation",
     element:  (
      <Suspense fallback={<div>Loading...</div>}>
        <>
          <AutodeskInventorAPI />
          <ContactButton />
        </>
      </Suspense>
    ),
  },
]);

export default function AppRoutes() {
  return <RouterProvider router={router} />;
}